import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {Link, useLocation, useParams} from "react-router-dom";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {
    getCategoryTypesAll,
    getCurrentCategoryType,
    resetUpdateCategoryTypeStatus,
    updateCategoryType
} from "../../store/reducers/CategoryTypesSlice";
import {RequestStatus} from "../../utils/Enums";
import {getCurrentCategory, updateCategory, resetUpdateCategoryStatus} from "../../store/reducers/CategoriesSlice";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import ElogTextarea from "../common/form/ElogTextarea";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface ModifyCategoryScreenProps {
}

export interface ModifyCategoryFormProps {
    name: string;
    type: string;
    comment: string;
}

export const ModifyCategoryScreen: React.FC<ModifyCategoryScreenProps> = () => {

    const dispatch = useAppDispatch();
    const location = useLocation();

    const {id} = useParams();

    const categoryTypesState = useAppSelector(state => state.categoryTypes);
    const categoriesState = useAppSelector(state => state.categories);

    const requestStatus: RequestStatus = categoriesState.updateCategoryStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: 'Grupid', url: '/categories'},
        {text: 'Grupi muutmine', url: '/categories/modify'},
    ];

    useEffect(() => {
        dispatch(resetUpdateCategoryStatus());
    }, [location]);

    useEffect(() => {
        dispatch(getCurrentCategory({id}));
        dispatch(getCategoryTypesAll());
    }, [id]);

    const categoryTypesOptions: Option[] = categoryTypesState.categoryTypes.map((category) => ({
        value: category.id.toString(),
        label: category.name,
    }));

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            name: categoriesState?.currentCategory?.name ?? '',
            type: categoriesState?.currentCategory?.type?.id ?? '',
            comment: categoriesState?.currentCategory?.comment ?? ''
        },
        onSubmit: (values: any) => {
            dispatch(updateCategory({id, data: values}));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Success &&
            <div className="message msg-ok">
              <div>
                <h2>Andmed muudetud</h2>
              </div>
            </div>
            }
            {requestStatus === RequestStatus.Failed && categoriesState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {categoryTypesState.errors.map((error, index) => (
                            <span key={index}>{error}<br /></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2><span>Grupi tüübi andmed</span></h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Nimi" name="name" mandatory={true}/>
                            <ElogSelect label="Tüüp" name="type" options={categoryTypesOptions} mandatory={true} />
                            <ElogTextarea label="Kommentaar" name="comment" />
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                <span><strong>Muuda</strong></span>
                            </button>
                            <Link to="/category-types">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    )

}